<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol" style="width: 800px">
      <table class="co-executor">
        <thead>
          <tr>
            <td>Название банка</td>
            <td>Сумма, тыс. руб.</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div style="float: right;">
                <b>Общая сумма займа, тыс. руб. (с учетом процентов)</b>
                &nbsp;&nbsp;&nbsp;
              </div>
            </td>
            <td colspan="2">
              <input
                type="text"
                v-model="$parent.project.UF_ALL_SUMM_PROCENT"
                class="i-main-style tab-wid-76"
                disabled
              />
            </td>
          </tr>
          <template
            v-for="(item, index) in $parent.project.BANK_GUARANTEE.items"
          >
            <bank_guarantee_list
              :item="item"
              :index="index"
              v-bind:key="index"
            ></bank_guarantee_list>
          </template>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" v-on:click="addItem"
          >Добавить банковскую гарантию</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Bank_guarantee_list from "@/components/project/form/lists/BankGuaranteeList";
import Vue from "vue";

export default {
  name: "bank_guarantee",
  props: ["project"],
  components: {
    Bank_guarantee_list
  },

  methods: {
    hasBankGuarantError(col, field) {
      if (typeof this.$parent.$parent.bankGuarantErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.bankGuarantErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    bankGuarantErrorText(col, field) {
      if (typeof this.$parent.$parent.bankGuarantErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.bankGuarantErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.bankGuarantErrors[col][field];
        }
      }
      return "";
    },
    removeBankGuarantError(col, field) {
      if (typeof this.$parent.$parent.bankGuarantErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.bankGuarantErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.bankGuarantErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.$parent.project.BANK_GUARANTEE === "undefined") {
        this.$parent.project.BANK_GUARANTEE = {
          items: []
        };
      }
      this.$parent.project.BANK_GUARANTEE.items.push({});
    },

    deleteItem(index) {
      this.$parent.project.BANK_GUARANTEE.items.splice(index, 1);
      if (this.$parent.project.BANK_GUARANTEE.items.length === 0) {
        this.$parent.project.BANK_GUARANTEE.items.push({});
      }
    }
  }
};
</script>

<style scoped></style>
